import React, { Component, Fragment } from 'react';
import { LanguageConsumer, Translate } from '../../contexts/LanguageContext';
import { Card, Loading, BreadCrumb, Modal } from '../../components';
import { UserService } from '../../services/UserService';

export class UserAccounts extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            userAccounts: [],
            modal: false,
            whiteList: {
                login: 0,
                address: null,
            },
            whiteListData: [],
            error: false,
            errorMessage: "",
        }
    }


    getWhiteListData() {
        UserService.Account.WhiteList().then((response) => {
            if (response) {
                this.setState({
                    whiteListData: response,
                    loading: false
                });
            } else {
                this.setState({
                    loading: false
                });
            }
        });
    }
    componentWillMount() {
        UserService.Account.All().then((response) => {
            if (response) {
                this.setState({
                    userAccounts: response,
                    loading: false
                });
            } else {
                this.setState({
                    loading: false
                });
            }
        });
        this.getWhiteListData();
    }

    addWhiteList() {
        if (!this.state.whiteList.address) {
            this.setState({ modal: false });
        }
        const postData = this.state.whiteList;
        if (postData.login === 0) {
            postData.login = this.state.userAccounts[0].login;
        }
        UserService.Account.AddAddressWhiteList(this.state.whiteList).then(response => {
            if (response) {
                if (response.error === false) {
                    this.getWhiteListData();
                    this.setState({ error: false, errorMessage: '' })
                } else {
                    this.setState({ error: true, errorMessage: response.message })
                }
            }
        });
    }

    handleChange(e) {
        this.setState({ whiteList: { ...this.state.whiteList, [e.target.name]: e.target.value } });
    }
    render() {
        let userAccountsList = this.state.userAccounts.map(item => (
            <tr key={item.login}>
                <th scope="row">{item.login}</th>
                <td>{item.name}</td>
                <td>{item.email}</td>
                <td>{item.country}</td>
                <td>{item.equity.toFixed(2).format('c')}</td>
                <td>{item.balance.toFixed(2).format('c')}</td>
                <td>{item.margin.toFixed(2).format('c')}</td>
                <td>{item.margin_Free.toFixed(2).format('c')}</td>
                <td>{item.margin_Level.toFixed(2).format('c')}</td>
                <td>{item.profit.toFixed(2).format('c')}</td>
            </tr>
        ))
        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title="Loading Content" />
                        <BreadCrumb Title="User Accounts" Name="User Accounts" />
                        <div className="row">
                            <div className="col-md-12">

                                <Card Title="Accounts" Description="Your accounts list" >
                                    <div className="row">

                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 text-right">
                                            <button type="button" className="btn btn-primary" onClick={() => this.setState({ modal: true })}>{Translate('Add Coin Address')}</button>
                                        </div>
                                    </div>
                                    <div className="row mt-1">
                                        <div className="col-md-12">
                                            <div className="table-responsive">
                                                <table className="table table-hover mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th scope="col">{Translate('Login')}</th>
                                                            <th scope="col">{Translate('Name')}</th>
                                                            <th scope="col">{Translate('Email')}</th>
                                                            <th scope="col">{Translate('Country')}</th>
                                                            <th scope="col">{Translate('Equity')}</th>
                                                            <th scope="col">{Translate('Balance')}</th>
                                                            <th scope="col">{Translate('Margin')}</th>
                                                            <th scope="col">{Translate('Free Margin')}</th>
                                                            <th scope="col">{Translate('Margin Level')}</th>
                                                            <th scope="col">{Translate('Profit')}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {userAccountsList}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        </div>
                        <Modal Title={Translate("Add Coin Address")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                            <div className="row mt-1 mb-1">
                                <div className={"col-md-12 " + (this.state.error ? "" : "d-none")}>
                                    <div className={"alert alert-danger alert-dismissible fade mb-0 show"} role="alert">
                                        <button type="button" className="close" data-dismiss="alert" aria-label="Close">
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                        <strong>{Translate("Error !")}</strong> {this.state.errorMessage}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="alert alert-danger mb-0" role="alert">
                                        {Translate("NOTE: Please add cold wallet to the system. If the cold wallet address is not added, you must inform us about the tether to be sent.")}
                                        
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <form className="form-horizontal m-t-30" ref={this.inputRefs}>
                                        <div className="form-group">
                                            <label htmlFor="username">{Translate('Address')}</label>
                                            <input type="text" className="form-control" id="address" name="address" placeholder={Translate('Enter your coin address.')} onChange={(e) => this.handleChange(e)} />
                                        </div>

                                        <div className="form-group">
                                            <label htmlFor="userpassword">{Translate('Login')}</label>
                                            <select className="form-control" value={this.state.whiteList.login} name="login" id="login" onChange={(e) => this.handleChange(e)}>
                                                {
                                                    this.state.userAccounts.map(item => (<option value={item.login}>{item.login}</option>))
                                                }
                                            </select>
                                        </div>
                                        <div className="form-group">
                                            <button type="button" className="btn btn-success" onClick={() => this.addWhiteList()}>{Translate('Save')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <label>{Translate('Coin Address List')}</label>
                                    <hr></hr>
                                </div>
                                <div className="col-md-12">
                                    <table className="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th scope="col">{Translate('Login')}</th>
                                                <th scope="col">{Translate('Address')}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {Array.isArray(this.state.whiteListData) && this.state.whiteListData.map(item => (<tr><td>{item.login}</td><td>{item.address}</td></tr>))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </Modal>

                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}